import React from 'react';
import atom from './atom.png';
import books from './books.png';
import email from './email3.png';
import team from './team.png';
import './App.css';
import './main.css'; 
import './index.css';
import CategoryPage from './CategoryPage';
import * as contentful from 'contentful';
import Markdown from 'react-markdown';

class App extends React.Component {

	state={
		main: [],
		team: [],
		research: [],
		teaching: [],
		contact: [],
		display: {
			intro: "hide",
			work: "hide",
			about: "hide",
			contact: "hide",
			header: "active" }
	}

	client = contentful.createClient({
		space: 'bo6q0poasazn',
		accessToken: 'c9af1dd32ae7b834aae5503e22075a447cd8018f91046a64489731678038c3ae' });

	componentDidMount() {
		this.fetchEntries().then(this.setEntries);
	  }
	  fetchEntries = () => this.client.getEntries()
	  .then((response) => {
		  let main;
		  let team;
		  let research;
		  let teaching;
		  let contact;
		response.items.forEach(entry => {
			if(entry.sys.contentType.sys.id === "siteSettings") {
				main = entry.fields;
			}
			if(entry.sys.contentType.sys.id === "team") {
			  team = entry.fields;
			}
			if(entry.sys.contentType.sys.id === "research") {
				research = entry.fields;
				//console.log(entry.fields);
			}
			if(entry.sys.contentType.sys.id === "teaching") {
				teaching = entry.fields;
			}
			if(entry.sys.contentType.sys.id === "contact") {
				contact = entry.fields;
			}
		  })
		this.setState({
		  main: main,
		  team: team,
		  research: research,
		  teaching: teaching,
		  contact: contact
		})
	  })
	  .catch(console.error)

	  click = (e, href) => {
		let temp = this.state.display;

		temp[href] = "active";
		temp["header"] = "hide";
		//console.log(temp);
		//console.log(this.state.display);
		this.setState({
			display: temp
		});
	  }

	  exit = (href) => {
		let temp = this.state.display;
		temp[href] = "hide"
		temp["header"] = "active";
		//console.log("closing " + href);
		//console.log(this.state.display);
		this.setState({
			display: temp
		});
		this.scrollToTop();
	  }

	  scrollToTop = () => {
		this.header.scrollIntoView({block: "start", inline: "nearest"});
	  }


  render() {
	  //console.log(this.state.team);
    return (	      
	      <body className="is-preload">
			<header>
		      <title>Swati's Site</title>
		      <meta charSet="utf-8" />
	      	<meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=no" />
		      <link rel="stylesheet" href="assets/css/main.css" />
		      <noscript><link rel="stylesheet" href="css/noscript.css" /></noscript>
	      </header>
		    {/* Wrapper */}
			  <div id="wrapper">

				  {/* Header */}
				  <div className={this.state.display.header}>
					<header id="header">
						{/*<div className="logo">
							<span className="icon fa-diamond"></span>
						</div>*/}
						<div className="content"
							ref={(el) => { this.header = el; }}>
							<div className="inner">
								<Markdown>{this.state.main.header}</Markdown>
							</div>
						</div>
						<nav>
							<ul>
								<li><a href="#intro" onClick={(click) => this.click(click, "intro")}><img src={team} alt="team"></img>
								<br/>Team</a></li>
								<li><a href="#work" onClick={(click) => this.click(click, "work")}><img src={books} alt="books"></img>
								<br/>Teaching</a></li>
								<li><a href="#about" onClick={(click) => this.click(click, "about")}><img src={atom} alt="atom"></img>
								<br/>Research</a></li>
								<li><a href="#contact" onClick={(click) => this.click(click, "contact")}><img src={email} alt="email"></img>
								<br/>Contact</a></li>
								{/*<li><a href="#elements">Elements</a></li>*/}
							</ul>
						</nav>
					</header>
					<div id="recentNews">
						<Markdown>
							{this.state.main.recentNews}
						</Markdown>
					</div>
					</div>

				{/* Main */}
					<div id="main">
						{/* About */}
						<article id="intro"
								className={this.state.display.intro}>
								<h2 className="major">
									<span>Team</span>
									<div className="close"
										onClick={() => this.exit("intro")}>
									</div>
								</h2>
								<CategoryPage
									category={this.state.team}>
								</CategoryPage>
							</article>

						{/* Research */}
							<article id="about"
								className={this.state.display.about}>
								<h2 className="major">
									<span>Research</span>
									<div className="close"
											onClick={() => this.exit("about")}>
									</div>
								</h2>
								<CategoryPage
									category={this.state.research}>
								</CategoryPage>
							</article>

						{/* Work */}
							<article id="work"
								className={this.state.display.work}>
								<h2 className="major">
									<span>Teaching</span>
									<div className="close"
											onClick={() => this.exit("work")}>
									</div>
								</h2>
								<CategoryPage
									category={this.state.teaching}>
								</CategoryPage>
								
							</article>

						{/* Contact */}
							<article id="contact"
								className={this.state.display.contact}>
								<h2 className="major">
									<span>Contact</span>
									<div className="close"
											onClick={() => this.exit("contact")}>
									</div>
								</h2>
								<CategoryPage
									category={this.state.contact}>
								</CategoryPage>
							</article> {/*Contact*/}
					</div>

				{/* Footer */}
					<footer id="footer">
						<p className="copyright">&copy; Untitled. Design: <a href="https://html5up.net">HTML5 UP</a>.
						<br></br>
						React-ified by <a href="https://github.com/agusakov">agusakov</a>
						<br></br>
						Icons made by <a href="https://www.freepik.com/" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" 			    title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" 			    title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a></p>
					</footer>

			</div>

		{/* BG */}
			<div id="bg"></div>

		{/* Scripts /}
			<script src="./js/jquery.min.js"></script>
			<script src="./js/browser.min.js"></script>
			<script src="./js/breakpoints.min.js"></script>
			<script src="./js/util.js"></script>
<script src="./js/main.js"></script>*/}

	</body>
    );
  }
}

export default App;
